import { useEffect } from 'react'
import { getAllProjects, getProjectById } from '../../../services/sBook/project.service'

const useGetProjects = (projects, setProjects) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllProjects();
                const response = serviceResponse.data;

                setProjects(response);
            }
            catch (error) {
            }
        }
        
        if (projects.data === null) {
            getData()
        }
    }, [projects, setProjects]);
}

const useGetProjectsMaintainer = (projects, setProjects) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllProjects();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        aux_array.push({id: element.id , name: element.name, projectCode: element.code, projectNemo: ""})
                    });
                }

                setProjects(aux_array);
            }
            catch (error) {
                setProjects([]);
            }
        }
        
        if (projects === null) {
            getData()
        }
    }, [projects, setProjects]);
}

const useGetProjectById = (projectId, project, setProject) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getProjectById(projectId);
                const response = serviceResponse;

                setProject(response);
            }
            catch (error) {
            }
        }
        
        if (project === null && projectId !== null) {
            getData()
        }
    }, [projectId, project, setProject]);
}

export {
    useGetProjects,
    useGetProjectById,
    useGetProjectsMaintainer
}